import React from 'react';
import { Globe2 } from 'lucide-react';

/**
 * Reassures international buyers that the USD price is charged
 * in their own currency at checkout.
 */
export const LocalCurrencyNote = ({
  className = ''
}: {
  className?: string;
}) => <div className={`flex items-center justify-center gap-2 text-xs text-slate-400 ${className}`} data-id="element-368" data-mp="103h726tpprrm">
    <Globe2 size={14} className="shrink-0 text-sky-400" aria-hidden="true" data-id="element-369" data-mp="v5fm1gcq7idi" />
    <p data-id="element-370" data-mp="q7w9qlzl9fo7">
      <span className="font-semibold text-slate-200" data-id="element-371" data-mp="q7nxmwbaiee2">Pay in your local currency</span>{' '}
      — converted automatically at checkout.
    </p>
  </div>;